import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Select from "react-select"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as productAction from "../../../store/cHJvZHVjdERldGF/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import "./styles.scss"
import { MultiSelect } from "react-multi-select-component"
import api from "helpers/Api"
import ReactDOM from "react-dom"
import ProductDetailsStatusTab from "./ProductDetailsStatusTab"

const ProductDetailsStatusReport = (props) => {
  const { searchBtnStyle, dispatch } = props
 // const assignedCRMId = localStorage.getItem("empId")
  const title = "Product Details Status Report"
  const [productStatusData, setProductStatusData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })

  const [type, setType] = useState([])
  const typeOptions = [
    {
      label: "Deliverable",
      value: "Deliverable",
    },
    {
      label: "Unique Clients",
      value: "Unique Clients",
    },
    {
      label: "Leads",
      value: "Leads",
    },
  ]


  //Fetching API
  useEffect(() => {
    dispatch(productAction.loadProductStatus())
    dispatch(productAction.loadRecordsMetaData())

  }, [])

  //date format
  const update = useSelector(
    (specificstate) => specificstate.productDetailStatusReport
  )

  //product_data
  const { recordsMetaData = {}, product_data = [] } = update
  const productCategoryOptions = !isEmpty(recordsMetaData)
    ? recordsMetaData.productCategoryOptions
    : []
  const [productCategory, setProductCategory] = useState([])
  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  const handleChange = (e) => {
    setProductStatusData({
      ...productStatusData,
      [e.target.name]: e.target.value,
    })
  }

  const [downloadLoading, setDownloadLoading] = useState(false)

  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)
  const [searchValue, setSearchValue] = useState({})
  const products = productCategory && productCategory.map((m) => m.value)

  const handleFilter = (e) => {
    e.preventDefault()

    var searchProduct =
      !isEmpty(productCategory) && productCategory ? products : ""
    var searchType = !isEmpty(type) && type.value ? type.value : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchProduct) {
      searchvalue.productCategoryId = searchProduct
    }
    if (searchType) {
      searchvalue.type = searchType
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setSearchValue(searchvalue)
    dispatch(productAction.loadProductStatus(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 3000)
  }

  //reset

  const resetForm = () => {
    setType([])
    setSearchInput("")
    setProductCategory([])
    setProductStatusData({
      ...productStatusData,
      eventFromDate: "",
      eventToDate: "",
    })
    dispatch(productAction.loadProductStatus())
  }

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      productAction.loadProductStatus({
        searchFilter: searchInput
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchProduct =
      !isEmpty(productCategory) && productCategory ? products : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchType = !isEmpty(type) && type.value ? type.value : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchProduct) {
      searchvalue.productCategoryId = searchProduct
    }
    if (searchType) {
      searchvalue.type = searchType
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    setDownloadLoading(true)

    api
      .post(`/general_product_status_report`, searchvalue)
      .then((response) => {
        const productData = response && response.data.data.data
        const totals =
          !isEmpty(productData) &&
          productData.length > 0 &&
          productData.reduce(
            (acc, data) => {
              acc.totalPlPending +=
                (!isNaN(data.productProcessStatusCount["PL PENDING"])
                  ? data.productProcessStatusCount["PL PENDING"]
                  : 0) +
                (!isNaN(data.productProcessStatusCount["PENDING PL"])
                  ? data.productProcessStatusCount["PENDING PL"]
                  : 0)
              acc.totalClientPending += !isNaN(
                data.productProcessStatusCount["CLIENT PENDING"]
              )
                ? data.productProcessStatusCount["CLIENT PENDING"]
                : 0
              acc.totalEwPending += !isNaN(
                data.productProcessStatusCount["EW PENDING"]
              )
                ? data.productProcessStatusCount["EW PENDING"]
                : 0
              acc.totalEwQueue += !isNaN(
                data.productProcessStatusCount["EW QUEUE"]
              )
                ? data.productProcessStatusCount["EW QUEUE"]
                : 0
              acc.totalEwInProgress += !isNaN(
                data.productProcessStatusCount["EW INPROGRESS"]
              )
                ? data.productProcessStatusCount["EW INPROGRESS"]
                : 0
              acc.totalEwCompleted += !isNaN(
                data.productProcessStatusCount["EW COMPLETED"]
              )
                ? data.productProcessStatusCount["EW COMPLETED"]
                : 0
              acc.totalSharedToClient += !isNaN(
                data.productProcessStatusCount["EW QC COMPLETED"]
              )
                ? data.productProcessStatusCount["EW QC COMPLETED"]
                : 0
              acc.totalQcRecheck += !isNaN(
                data.productProcessStatusCount["QC RECHECK"]
              )
                ? data.productProcessStatusCount["QC RECHECK"]
                : 0
              acc.totalOnHold += !isNaN(
                data.productProcessStatusCount["ON HOLD"]
              )
                ? data.productProcessStatusCount["ON HOLD"]
                : 0
              acc.totalEwChanges += !isNaN(
                data.productProcessStatusCount["CLIENT CHANGES"]
              )
                ? data.productProcessStatusCount["CLIENT CHANGES"]
                : 0
              acc.totalEwRework += !isNaN(
                data.productProcessStatusCount["CLIENT REWORK"]
              )
                ? data.productProcessStatusCount["CLIENT REWORK"]
                : 0
              acc.totalNotApplicable += !isNaN(
                data.productProcessStatusCount["NOT APPLICABLE"]
              )
                ? data.productProcessStatusCount["NOT APPLICABLE"]
                : 0

              return acc
            },
            {
              totalPlPending: 0,
              totalClientPending: 0,
              totalEwPending: 0,
              totalEwQueue: 0,
              totalEwInProgress: 0,
              totalEwCompleted: 0,
              totalSharedToClient: 0,
              totalQcRecheck: 0,
              totalOnHold: 0,
              totalEwChanges: 0,
              totalEwRework: 0,
              totalNotApplicable: 0,
            }
          )
        const endTotal = totals.totalPlPending + totals.totalClientPending + totals.totalEwPending + totals.totalEwQueue +
          totals.totalEwInProgress + totals.totalEwCompleted + totals.totalSharedToClient +
          totals.totalQcRecheck + totals.totalOnHold + totals.totalEwChanges + totals.totalEwRework + totals.totalNotApplicable
        const photoExportDataTable = !isEmpty(response.data.data.data)
          ? response.data.data.data
            .map((data, index) => {
              const plPendingCount =
                data.productProcessStatusCount["PL PENDING"] || 0
              const pendingPlCount =
                data.productProcessStatusCount["PENDING PL"] || 0
              const totalPlPendingCount = plPendingCount + pendingPlCount
              const clientPendingValue =
                data.productProcessStatusCount["CLIENT PENDING"] || 0
              const EWPendingValue =
                data.productProcessStatusCount["EW PENDING"] || 0
              const EWQueueValue =
                data.productProcessStatusCount["EW QUEUE"] || 0
              const EWQueueSubValue =
                data.productProcessStatusCount["EW INPROGRESS"] || 0
              const EWCompletedValue =
                data.productProcessStatusCount["EW COMPLETED"] || 0
              const shareToClientValue =
                data.productProcessStatusCount["EW QC COMPLETED"] || 0
              const qcRecheckValue =
                data.productProcessStatusCount["QC RECHECK"] || 0
              const onHoldValue =
                data.productProcessStatusCount["ON HOLD"] || 0
              const ewChangesValue =
                data.productProcessStatusCount["CLIENT CHANGES"] || 0
              const ewReworkValue =
                data.productProcessStatusCount["CLIENT REWORK"] || 0
              const notApplicableValue =
                data.productProcessStatusCount["NOT APPLICABLE"] || 0

              // Include subProduct data
              const subProductRows = data.product.map(
                (subProduct, subIndex) => {
                  const plPendingVal =
                    subProduct.processStatusCount["PL PENDING"] || 0
                  const pendingPlVal =
                    subProduct.processStatusCount["PENDING PL"] || 0
                  const totalPlPendingValue = plPendingVal + pendingPlVal
                  const subRowArray = [
                    totalPlPendingValue,
                    subProduct.processStatusCount["CLIENT PENDING"],
                    subProduct.processStatusCount["EW PENDING"],
                    subProduct.processStatusCount["EW QUEUE"],
                    subProduct.processStatusCount["EW INPROGRESS"],
                    subProduct.processStatusCount["EW COMPLETED"],
                    subProduct.processStatusCount["EW QC COMPLETED"],
                    subProduct.processStatusCount["CLIENT REWORK"],
                    subProduct.processStatusCount["CLIENT CHANGES"],
                    subProduct.processStatusCount["QC RECHECK"],
                    subProduct.processStatusCount["ON HOLD"],
                    subProduct.processStatusCount["NOT APPLICABLE"],
                  ]
                  const rowWiseTotal = subRowArray.reduce((acc, val) => {
                    const accValue = !isNaN(acc) ? acc : 0
                    const itemValue = !isNaN(val) ? val : 0
                    const data = parseInt(accValue + itemValue)
                    return data
                  }, 0)
                  return {
                    _id: index + "-" + subIndex,
                    sNo: "",
                    productCategory: subProduct.productName || "",
                    PLPending: totalPlPendingValue,
                    clientPending:
                      subProduct.processStatusCount["CLIENT PENDING"] || 0,
                    EWPending:
                      subProduct.processStatusCount["EW PENDING"] || 0,
                    EWQueue: subProduct.processStatusCount["EW QUEUE"] || 0,
                    EWQueueSub:
                      subProduct.processStatusCount["EW INPROGRESS"] || 0,
                    EWCompleted:
                      subProduct.processStatusCount["EW COMPLETED"] || 0,
                    shareToClient:
                      subProduct.processStatusCount["EW QC COMPLETED"] || 0,
                    qcRecheck:
                      subProduct.processStatusCount["QC RECHECK"] || 0,
                    onHold: subProduct.processStatusCount["ON HOLD"] || 0,
                    ewChanges:
                      subProduct.processStatusCount["CLIENT CHANGES"] || 0,
                    ewRework: subProduct.processStatusCount["CLIENT REWORK"] || 0,
                    notApplicable:
                      subProduct.processStatusCount["NOT APPLICABLE"] || 0,
                    Total: rowWiseTotal

                  }
                }
              )
              const rowArray = [
                totalPlPendingCount,
                clientPendingValue,
                EWPendingValue,
                EWQueueValue,
                EWQueueSubValue,
                EWCompletedValue,
                shareToClientValue,
                ewReworkValue,
                ewChangesValue,
                qcRecheckValue,
                onHoldValue,
                notApplicableValue,
              ]
              const rowWiseTotal = rowArray.reduce((acc, val) => {
                const accValue = !isNaN(acc) ? acc : 0
                const itemValue = !isNaN(val) ? val : 0
                const data = parseInt(accValue + itemValue)
                return data
              }, 0)
              return [
                {
                  _id: index,
                  sNo: index + 1,
                  productCategory: data.productCategoryName || "",
                  PLPending: totalPlPendingCount,
                  clientPending: clientPendingValue,
                  EWPending: EWPendingValue,
                  EWQueue: EWQueueValue,
                  EWQueueSub: EWQueueSubValue,
                  EWCompleted: EWCompletedValue,
                  shareToClient: shareToClientValue,
                  qcRecheck: qcRecheckValue,
                  onHold: onHoldValue,
                  ewChanges: ewChangesValue,
                  ewRework: ewReworkValue,
                  notApplicable: notApplicableValue,
                  Total: rowWiseTotal
                },
                ...subProductRows,
              ]
            })
            .flat() // Flatten the array
          : []

        // Calculate totals
        const totalRow = {
          _id: "total",
          sNo: "",
          productCategory: "Total",
          PLPending: totals.totalPlPending,
          clientPending: totals.totalClientPending,
          EWPending: totals.totalEwPending,
          EWQueue: totals.totalEwQueue,
          EWQueueSub: totals.totalEwInProgress,
          EWCompleted: totals.totalEwCompleted,
          shareToClient: totals.totalSharedToClient,
          qcRecheck: totals.totalQcRecheck,
          onHold: totals.totalOnHold,
          ewChanges: totals.totalEwChanges,
          ewRework: totals.totalEwRework,
          notApplicable: totals.totalNotApplicable,
          Total: endTotal
        }

        photoExportDataTable.push(totalRow)

        setTimeout(() => {
          let headerData = [
            "S.No,Product Category,PL Pending,Client Pending,EW Pending,EW Queue,EW INProgress,EW Completed,Pending To Share,QC Recheck,On Hold,Client Rework,Client Changes,Not Applicable,Total",
          ]

          // Construct CSV content
          let usersCsv =
            !isEmpty(photoExportDataTable) &&
            photoExportDataTable.map((user) => [
              user.sNo,
              user.productCategory,
              user.PLPending,
              user.clientPending,
              user.EWPending,
              user.EWQueue,
              user.EWQueueSub,
              user.EWCompleted,
              user.shareToClient,
              user.qcRecheck,
              user.onHold,
              user.ewChanges,
              user.ewRework,
              user.notApplicable,
              user.Total,
            ])

          // Join header and data rows
          const csvContent = [headerData, ...usersCsv]
            .map((row) => row.join(","))
            .join("\n")

          // Download CSV file
          downloadFile({
            data: csvContent,
            fileName: "ProductDetailsStatusReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  //Data table Total functionality
  const totals =
    !isEmpty(product_data) &&
    product_data.length > 0 &&
    product_data.reduce(
      (acc, data) => {
        acc.totalPlPending +=
          (!isNaN(data.productProcessStatusCount["PL PENDING"])
            ? data.productProcessStatusCount["PL PENDING"]
            : 0) +
          (!isNaN(data.productProcessStatusCount["PENDING PL"])
            ? data.productProcessStatusCount["PENDING PL"]
            : 0)
        acc.totalClientPending += !isNaN(
          data.productProcessStatusCount["CLIENT PENDING"]
        )
          ? data.productProcessStatusCount["CLIENT PENDING"]
          : 0
        acc.totalEwPending += !isNaN(
          data.productProcessStatusCount["EW PENDING"]
        )
          ? data.productProcessStatusCount["EW PENDING"]
          : 0
        acc.totalEwQueue += !isNaN(data.productProcessStatusCount["EW QUEUE"])
          ? data.productProcessStatusCount["EW QUEUE"]
          : 0
        acc.totalEwInProgress += !isNaN(
          data.productProcessStatusCount["EW INPROGRESS"]
        )
          ? data.productProcessStatusCount["EW INPROGRESS"]
          : 0
        acc.totalEwCompleted += !isNaN(
          data.productProcessStatusCount["EW COMPLETED"]
        )
          ? data.productProcessStatusCount["EW COMPLETED"]
          : 0
        acc.totalSharedToClient += !isNaN(
          data.productProcessStatusCount["EW QC COMPLETED"]
        )
          ? data.productProcessStatusCount["EW QC COMPLETED"]
          : 0
        acc.totalQcRecheck += !isNaN(
          data.productProcessStatusCount["QC RECHECK"]
        )
          ? data.productProcessStatusCount["QC RECHECK"]
          : 0
        acc.totalOnHold += !isNaN(data.productProcessStatusCount["ON HOLD"])
          ? data.productProcessStatusCount["ON HOLD"]
          : 0
        acc.totalEwChanges += !isNaN(
          data.productProcessStatusCount["CLIENT CHANGES"]
        )
          ? data.productProcessStatusCount["CLIENT CHANGES"]
          : 0
        acc.totalEwRework += !isNaN(data.productProcessStatusCount["CLIENT REWORK"])
          ? data.productProcessStatusCount["CLIENT REWORK"]
          : 0
        acc.totalNotApplicable += !isNaN(
          data.productProcessStatusCount["NOT APPLICABLE"]
        )
          ? data.productProcessStatusCount["NOT APPLICABLE"]
          : 0

        return acc
      },
      {
        totalPlPending: 0,
        totalClientPending: 0,
        totalEwPending: 0,
        totalEwQueue: 0,
        totalEwInProgress: 0,
        totalEwCompleted: 0,
        totalSharedToClient: 0,
        totalQcRecheck: 0,
        totalOnHold: 0,
        totalEwChanges: 0,
        totalEwRework: 0,
        totalNotApplicable: 0,
      }
    )
  //tab functionality

  const handleClickTab = (tableData) => {

    const statusName = tableData.status
    const date = tableData.date
    const statusDetails = {
      productCategoryId: tableData.productCategoryId,
      productionProcessStatus: tableData.productionProcessStatus,
      productId: tableData.productId,
   //   assignedCRMId: assignedCRMId,
      isPending: tableData.isPending

    }

   
    if (searchValue.eventFromDate) {
      statusDetails.eventFromDate = searchValue.eventFromDate
    }
    if (searchValue.eventToDate) {
      statusDetails.eventToDate = searchValue.eventToDate
    }



    api
      .post(`/general_product_status_report_details`, statusDetails)
      .then((response) => {
        const statusData = !isEmpty(response.data.data) ? response.data.data : []
        setTimeout(() => {
          // Use the current value of statusData, which should be updated due to the useEffect

          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <ProductDetailsStatusTab
                data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={statusDetails}
                name={statusName}
                dateFormat={dateFormat}
                date={date}
              />,
              container
            )
            newTab.document.title = "CRM-WISE-PRODUCT-STATUS-REPORT"
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)

      })
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Product Category"}
                        >
                          {"Product Category"}
                        </Label>
                      </div>

                      <MultiSelect
                        options={productCategoryOptions}
                        value={productCategory}
                        onChange={setProductCategory}
                        labelledBy="Select"
                        hasSelectAll={true}
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={productStatusData.eventFromDate}
                        max={productStatusData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={productStatusData.eventToDate}
                        min={productStatusData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Product Category"}
                        >
                          {"Type"}
                        </Label>
                      </div>

                      <Select
                        options={typeOptions}
                        value={type}
                        name="type"
                        placeholder="Select Type"
                        onChange={(e) => setType(e)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>

                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>
                <Row>
                  <Col md="4" lg="4" sm="12"></Col>
                  <Col
                    md="8"
                    lg="8"
                    sm="12"
                    style={{ marginBottom: "20px", marginTop: "-41px" }}
                  >
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Col md="12" lg="12" xl="12" className="mt-3">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                    
                        <th style={{ minWidth: "210px", position: "sticky", left: 0, zIndex: 3,  boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",   paddingLeft: "10px",}}>Product Category</th>
                        <th style={{ minWidth: "210px" }}>PL PENDING</th>
                        <th style={{ minWidth: "210px" }}>CLIENT PENDING</th>
                        <th style={{ minWidth: "210px" }}>EW PENDING</th>
                        <th style={{ minWidth: "210px" }}>EW QUEUE</th>
                        <th style={{ minWidth: "210px" }}>EW INPROGRESS</th>
                        <th style={{ minWidth: "210px" }}>EW COMPLETED</th>
                        <th style={{ minWidth: "210px" }}>Pending To Share</th>
                        <th style={{ minWidth: "210px" }}>QC RECHECK</th>
                        <th style={{ minWidth: "210px" }}>ON HOLD</th>
                        <th style={{ minWidth: "210px" }}>CLIENT CHANGES</th>
                        <th style={{ minWidth: "210px" }}>CLIENT REWORK</th>
                        <th style={{ minWidth: "210px" }}>NOT APPLICABLE</th>
                        <th style={{ minWidth: "210px" }}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(product_data) &&
                        product_data.map((data, index) => {
                          const plPendingCount =
                            data.productProcessStatusCount["PL PENDING"]
                          const pendingPlCount =
                            data.productProcessStatusCount["PENDING PL"]
                          const totalPlPendingCount =
                            plPendingCount + pendingPlCount

                          const productSubCount = data && data.product
                          const subProductData = !isEmpty(productSubCount)
                            ? productSubCount
                            : []
                          //get process status
                          const plPendingId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "PL PENDING") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "PL PENDING").processStatusId : ""

                          const clientPendingId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "CLIENT PENDING") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "CLIENT PENDING").processStatusId : ""

                          const ewPendingId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "EW PENDING") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "EW PENDING").processStatusId : ""

                          const ewQueueId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "EW QUEUE") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "EW QUEUE").processStatusId : ""

                          const ewInprogressId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "EW QUEUE") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "EW QUEUE").processStatusId : ""

                          const ewCompletedId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "EW COMPLETED") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "EW COMPLETED").processStatusId : ""

                          const ewQcCompletedId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "EW QC COMPLETED") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "EW QC COMPLETED").processStatusId : ""

                          const qcRecheckId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "QC RECHECK") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "QC RECHECK").processStatusId : ""

                          const onHoldId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "ON HOLD") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "ON HOLD").processStatusId : ""

                          const ewChangesId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "CLIENT CHANGES") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "CLIENT CHANGES").processStatusId : ""

                          const ewReworkId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "CLIENT REWORK") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "CLIENT REWORK").processStatusId : ""

                          const notApplicableId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                            recordsMetaData.deliverOptions.find(m => m.label == "NOT APPLICABLE") &&
                            recordsMetaData.deliverOptions.find(m => m.label == "NOT APPLICABLE").processStatusId : ""


                          //get product category id
                          const productCategoryId = recordsMetaData && !isEmpty(recordsMetaData.productCategoryOptions) ?
                            recordsMetaData.productCategoryOptions.find(m => m.label == data.productCategoryName) &&
                            recordsMetaData.productCategoryOptions.find(m => m.label == data.productCategoryName).value : ""

                          const plPendingMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: plPendingId,
                            date: "assignCRMDate"
                          }

                          const clientPendingMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: clientPendingId,
                            date: "processDate"
                          }

                          const ewPendingMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: ewPendingId,
                            date: "assignTeamLeadDate"
                          }

                          const ewQueueMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: ewQueueId,
                            isPending: false,
                            date: "assignEmpDate"
                          }

                          const ewInProgressMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: ewInprogressId,
                            isPending: true,
                            date: "subStatusDate"
                          }

                          const ewCompletedMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: ewCompletedId,
                            date: "processDate"
                          }

                          const ewQcCompletedMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: ewQcCompletedId,
                            date: "processDate"
                          }

                          const qcRecheckMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: qcRecheckId,
                            date: "processDate"
                          }

                          const onHoldMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: onHoldId,
                            date: "processDate"
                          }

                          const ewChangesMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: ewChangesId,
                            date: "processDate"
                          }

                          const ewReworkMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: ewReworkId,
                            date: "processDate"
                          }

                          const notApplicableMainValue = {
                            productCategoryId: productCategoryId,
                            productionProcessStatus: notApplicableId,
                            date: "processDate"
                          }
                          const rowArray = [
                            totalPlPendingCount,
                            data.productProcessStatusCount["CLIENT PENDING"],
                            data.productProcessStatusCount["EW PENDING"],
                            data.productProcessStatusCount["EW QUEUE"],
                            data.productProcessStatusCount["EW INPROGRESS"],
                            data.productProcessStatusCount["EW COMPLETED"],
                            data.productProcessStatusCount["EW QC COMPLETED"],
                            data.productProcessStatusCount["CLIENT REWORK"],
                            data.productProcessStatusCount["CLIENT CHANGES"],
                            data.productProcessStatusCount["QC RECHECK"],
                            data.productProcessStatusCount["ON HOLD"],
                            data.productProcessStatusCount["NOT APPLICABLE"],
                          ]
                          const rowWiseTotal = rowArray.reduce((acc, val) => {
                            const accValue = !isNaN(acc) ? acc : 0
                            const itemValue = !isNaN(val) ? val : 0
                            const data = parseInt(accValue + itemValue)
                            return data
                          }, 0)
                          return (
                            <>
                              <tr key={index}>
                                {/* <th style={{
                                   backgroundColor: "#83D4AB", 
                                   minWidth: "50px", position: "sticky", left: 0, zIndex: 3,
                                  boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)"  , // Optional visual effect
                                  paddingLeft: "10px",
                                }}>{index + 1}</th> */}
                                <th style={{
                                  backgroundColor: "#83D4AB",  minWidth: "210px", position: "sticky", left: 0, zIndex: 3,
                                  boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",  paddingLeft: "10px",
                                }}>{data.productCategoryName}</th>
                                <td
                                  onClick={() => handleClickTab(plPendingMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                    zIndex: 1,
                                  }}
                                >
                                  {totalPlPendingCount || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(clientPendingMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                     backgroundColor: "#83D4AB",
                                    zIndex: 1,
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "CLIENT PENDING"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(ewPendingMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                     backgroundColor: "#83D4AB",
                                    zIndex: 1,
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "EW PENDING"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(ewQueueMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                     backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount["EW QUEUE"] ||
                                    0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(ewInProgressMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "EW INPROGRESS"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(ewCompletedMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "EW COMPLETED"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(ewQcCompletedMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "EW QC COMPLETED"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(qcRecheckMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "QC RECHECK"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(onHoldMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount["ON HOLD"] ||
                                    0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(ewChangesMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >


                                  {data.productProcessStatusCount[
                                    "CLIENT CHANGES"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(ewReworkMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "CLIENT REWORK"
                                  ] || 0}
                                </td>
                                <td
                                  onClick={() => handleClickTab(notApplicableMainValue)}
                                  style={{
                                    color: "#e40d8c",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    backgroundColor: "#83D4AB",
                                  }}
                                >
                                  {data.productProcessStatusCount[
                                    "NOT APPLICABLE"
                                  ] || 0}
                                </td>
                                <td
                                  style={{
                                    backgroundColor: "#83D4AB",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {rowWiseTotal || 0}
                                </td>
                              </tr>
                              {subProductData &&
                                subProductData.map((item, ix) => {
                                  const plPending =
                                    item.processStatusCount["PL PENDING"]
                                  const pendingPl =
                                    item.processStatusCount["PENDING PL"]
                                  const totalPlPending = plPending + pendingPl
                                  //tab payload
                                  const productId = recordsMetaData && !isEmpty(recordsMetaData.productListOptions) ?
                                    recordsMetaData.productListOptions.find(m => m.label == item.productName) &&
                                    recordsMetaData.productListOptions.find(m => m.label == item.productName).value : ""
                                  //tab payload
                                  const plPendingSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: plPendingId,
                                    productId: productId,
                                    date: "assignCRMDate"
                                  }

                                  const clientPendingSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: clientPendingId,
                                    productId: productId,
                                    date: "processDate"
                                  }

                                  const ewPendingSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: ewPendingId,
                                    productId: productId,
                                    date: "assignTeamLeadDate"
                                  }

                                  const ewQueueSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: ewQueueId,
                                    productId: productId,
                                    isPending: false,
                                    date: "assignEmpDate"
                                  }

                                  const ewInProgressSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: ewInprogressId,
                                    productId: productId,
                                    isPending: true,
                                    date: "subStatusDate"
                                  }

                                  const ewCompletedSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: ewCompletedId,
                                    productId: productId,
                                    date: "processDate"

                                  }

                                  const ewQcCompletedSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: ewQcCompletedId,
                                    productId: productId,
                                    date: "processDate"
                                  }

                                  const qcRecheckSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: qcRecheckId,
                                    productId: productId,
                                    date: "processDate"
                                  }

                                  const onHoldSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: onHoldId,
                                    productId: productId,
                                    date: "processDate"
                                  }

                                  const ewChangesSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: ewChangesId,
                                    productId: productId,
                                    date: "processDate"
                                  }

                                  const ewReworkSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: ewReworkId,
                                    productId: productId,
                                    date: "processDate"
                                  }

                                  const notApplicableSubValue = {
                                    productCategoryId: productCategoryId,
                                    productionProcessStatus: notApplicableId,
                                    productId: productId,
                                    date: "processDate"
                                  }
                                  const subRowArray = [
                                    totalPlPending,
                                    item.processStatusCount["CLIENT PENDING"],
                                    item.processStatusCount["EW PENDING"],
                                    item.processStatusCount["EW QUEUE"],
                                    item.processStatusCount["EW INPROGRESS"],
                                    item.processStatusCount["EW COMPLETED"],
                                    item.processStatusCount["EW QC COMPLETED"],
                                    item.processStatusCount["CLIENT REWORK"],
                                    item.processStatusCount["CLIENT CHANGES"],
                                    item.processStatusCount["QC RECHECK"],
                                    item.processStatusCount["ON HOLD"],
                                    item.processStatusCount["NOT APPLICABLE"],
                                  ]
                                  const subRowWiseTotal = subRowArray.reduce((acc, val) => {
                                    const accValue = !isNaN(acc) ? acc : 0
                                    const itemValue = !isNaN(val) ? val : 0
                                    const data = parseInt(accValue + itemValue)
                                    return data
                                  }, 0)
                                  return (
                                    <tr key={ix}>
                                  
                                      <td style={{ minWidth: "210px", position: "sticky", left: 0, zIndex: 1 }}>{item.productName}</td>
                                      <td
                                        onClick={() => handleClickTab(plPendingSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {totalPlPending || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(clientPendingSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "CLIENT PENDING"
                                        ] || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(ewPendingSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "EW PENDING"
                                        ] || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(ewQueueSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount["EW QUEUE"] ||
                                          0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(ewInProgressSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "EW INPROGRESS"
                                        ] || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(ewCompletedSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "EW COMPLETED"
                                        ] || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(ewQcCompletedSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "EW QC COMPLETED"
                                        ] || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(qcRecheckSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "QC RECHECK"
                                        ] || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(onHoldSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount["ON HOLD"] ||
                                          0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(ewChangesSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "CLIENT CHANGES"
                                        ] || 0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(ewReworkSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount["CLIENT REWORK"] ||
                                          0}
                                      </td>
                                      <td
                                        onClick={() => handleClickTab(notApplicableSubValue)}
                                        style={{
                                          color: "#e40d8c",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item.processStatusCount[
                                          "NOT APPLICABLE"
                                        ] || 0}
                                      </td>
                                      <td
                                        style={{
                                          fontWeight: "bold"
                                        }}
                                      >
                                        {subRowWiseTotal}
                                      </td>
                                    </tr>
                                  )
                                })}
                            </>
                          )
                        })}
                      <tr>
                      
                        <th style={{ minWidth: "210px", position: "sticky", left: 0, zIndex: 1 }}>Total</th>
                        <th>{totals.totalPlPending}</th>
                        <th>{totals.totalClientPending}</th>
                        <th>{totals.totalEwPending}</th>
                        <th>{totals.totalEwQueue}</th>
                        <th>{totals.totalEwInProgress}</th>
                        <th>{totals.totalEwCompleted}</th>
                        <th>{totals.totalSharedToClient}</th>
                        <th>{totals.totalQcRecheck}</th>
                        <th>{totals.totalOnHold}</th>
                        <th>{totals.totalEwChanges}</th>
                        <th>{totals.totalEwRework}</th>
                        <th>{totals.totalNotApplicable}</th>
                        <th>{totals.totalPlPending + totals.totalClientPending + totals.totalEwPending + totals.totalEwQueue +
                          totals.totalEwInProgress + totals.totalEwCompleted + totals.totalSharedToClient +
                          totals.totalQcRecheck + totals.totalOnHold + totals.totalEwChanges + totals.totalEwRework + totals.totalNotApplicable}</th>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="font-size-14 mt-2">
                    <p>
                      {" "}
                      <p>{`Showing rows ${product_data && product_data.length > 0 ? 1 : 0
                        } to ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        } of ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        }`}</p>
                    </p>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
ProductDetailsStatusReport.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,ProductDetailsStatusReport
})
//ProductDetailsStatusReport
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductDetailsStatusReport)
)
